
import Vue from "vue";
import { Component } from "vue-property-decorator";
import AppBar from "@/components/layout/AppBar.vue";
import { i18n, loadMessagesAsync } from "@/i18n";
import Footer from "@/components/layout/Footer.vue";
import CookieConsentMessage from "@/components/common/CookieConsentMessage.vue";
import { authenticationService } from "@/services/authentication.service";
import { userService } from "@/services/user.service";
import store from "@/store";
import { translationService } from "@/services/translation.service";
import ContactDto from "@/contracts/generic/ContactDto";
import AllowedExtensionDto from "@/contracts/extension/AllowedExtensionsDto";
import { extensionService } from "@/services/extension.service";
import Banner from "@/components/banner/NotificationBanner.vue";
import NotificationBanner from "@/components/banner/NotificationBanner.vue";
import axios from "@/plugins/axios";
import { Locales } from "@/contracts/common/Language";
import { activityServicev2 } from "@/app/services/activity.service";
import ActivityWatcher from "@/components/activity-watcher.vue";
import FormDialogComponent from "@/app/components/dialog/form-dialog-component.vue";
import {FormDialogControl, FormDialogModel} from "@/app/components/dialog/form-dialog.model";
import {configManager, onHotkey} from "@/app/services/config.manager";
import {ExternalContext} from "@/app/contexts/externalContext";
import {RenderType} from "@/app/Types";

@Component({
  components: {
    FormDialogComponent,
    ActivityWatcher,
    NotificationBanner,
    Banner,
    CookieConsentMessage,
    AppBar,
    Footer,
  },
})
export default class App extends Vue {
  appKey = 0;

  public isMaintenancePath(){
    return this.$route.path.startsWith('/maintenance')
  }

  get translationsLoaded(): number {
    return Object.keys(i18n.messages).length;
  }
  async mounted(): Promise<void> {
    onHotkey({
      ctrlOrCmd: true,
      alt: true,
      key: 'd',
      callback: () => {
        this.debugControl?.show('',configManager.getConfig());
      }
    });
  }

  private debugModel: FormDialogModel  = {
    externalContext: new ExternalContext(),
    referenceType: "",
    referenceId: "",
    title: this.$tc("debug-manager.title"),
    submitLabel: this.$tc("debug-manager.submit"),
    destroyLabel: null,
    form: {
      id: "root",
      name: "",
      type: RenderType.LinearSection,
      displayMode: "editable",
      displayModeRule: "",
      computedValue: "",
      validators: [],
      metadata: {
        direction: "vertical",
      },
      children: [
        {
          id: "translations",
          name: "Translations",
          type: RenderType.Header,
          displayMode: "readonly",
          displayModeRule: "",
          computedValue: "",
          validators: [],
          metadata: {},
        },
        {
          id: "disabletranslations",
          name: "Disable translations",
          type: RenderType.Switch,
          displayMode: "editable",
          displayModeRule: "",
          computedValue: "",
          validators: [],
          metadata: {},
        },
        {
          id: "dynamicComponents",
          name: "Dynamic Components",
          type: RenderType.Header,
          displayMode: "readonly",
          displayModeRule: "",
          computedValue: "",
          validators: [],
          metadata: {},
        },
        {
          id: "modifyDynamicComponents",
          name: "Modify Dynamic components inline",
          type: RenderType.Switch,
          displayMode: "editable",
          displayModeRule: "",
          computedValue: "",
          validators: [],
          metadata: {},
        },
        {
          id: "debugDynamicComponents",
          name: "Dynamic components debug mode",
          type: RenderType.Switch,
          displayMode: "editable",
          displayModeRule: "",
          computedValue: "",
          validators: [],
          metadata: {},
        },
        {
          id: "showHiddenDynamicComponents",
          name: "Show hidden elements",
          type: RenderType.Switch,
          displayMode: "editable",
          displayModeRule: "",
          computedValue: "",
          validators: [],
          metadata: {},
        },
        {
          id: "editAllDynamicComponents",
          name: "Make all elements editable",
          type: RenderType.Switch,
          displayMode: "editable",
          displayModeRule: "",
          computedValue: "",
          validators: [],
          metadata: {},
        }
      ]
    }
  };
  private debugControl: FormDialogControl | null = null;
  private recieveDebugModal(control: FormDialogControl){
    this.debugControl = control;
    this.debugControl.submitChanges = (form, formData, referenceId) => {
      configManager.setConfig(formData);
      window.location.reload();
      return Promise.resolve(true);
    }
  }
}
